module.exports = __webpack_public_path__ + "static/media/transformer.40739060.svg";